export enum GridColType {
  FIELD = 'field',
  METRIC = 'metric'
}
